import type { ComponentProps } from 'react';
import { createRoot } from 'react-dom/client';
import { CrowdinThemeProvider } from '../components/crowdin-theme-provider';
import { readPageProps } from '../lib/page-props';
import { AboutPage } from '../pages/AboutPage';

const props = readPageProps<ComponentProps<typeof AboutPage>>();

createRoot(document.getElementById('root')!).render(
    <CrowdinThemeProvider>
        <AboutPage {...props} />
    </CrowdinThemeProvider>,
);
